import { ApiProperty, ApiPropertyOptional } from '@nestjs/swagger';
import { Exclude, Expose, Type } from 'class-transformer';
import { IsUUID } from 'class-validator';
import { SpOrderInterface } from '../../../sp/order/interfaces/sp-order.interface';
import { BuilderDto } from '../../../builder/dto/builder.dto';
import { SpConnectPurposeEnum } from '../../connect/enums/sp-connect-purpose.enum';
import { SpConnectOrderTypeEnum } from '../../connect/enums/sp-connect-order-type.enum';
import { SpConnectChangeTypeEnum } from '../../connect/enums/sp-connect-change-type.enum';
import { CommonEntityDto } from '../../../common/dto/common-entity.dto';
import { SpOrderItemDto } from '../../order-item/dtos/sp-order-item.dto';

@Exclude()
export class SpOrderDto extends CommonEntityDto implements SpOrderInterface {
  @ApiProperty({
    type: 'unknown',
    title: 'Raw Data',
  })
  @Expose()
  rawData!: unknown;

  @ApiProperty({
    title: 'SP Order ID',
  })
  @Expose()
  orderId!: number;

  @ApiProperty({
    title: 'SP Purpose',
    type: 'enum',
    enum: SpConnectPurposeEnum,
  })
  @Expose()
  purpose!: SpConnectPurposeEnum;

  @ApiProperty({
    title: 'SP order type',
    type: 'enum',
    enum: SpConnectOrderTypeEnum,
  })
  @Expose()
  orderType!: SpConnectOrderTypeEnum;

  @ApiProperty({
    type: 'date-time',
    title: 'Issue Date',
  })
  @Expose()
  @Type(() => Date)
  issueDate!: Date;

  @ApiProperty({
    title: 'SP builder order number',
  })
  @Expose()
  builderOrderNumber!: string;

  @ApiProperty({
    title: 'SP change type',
    type: 'enum',
    enum: SpConnectChangeTypeEnum,
  })
  @Expose()
  changeType!: SpConnectChangeTypeEnum;

  @ApiProperty({
    type: 'date-time',
    title: 'Change Order Issue Date',
  })
  @Expose()
  @Type(() => Date)
  changeOrderIssueDate!: Date;

  @ApiProperty({
    title: 'change order number',
  })
  @Expose()
  changeOrderNumber!: string;

  @ApiProperty({
    title: 'Change order sequence',
  })
  @Expose()
  changeOrderSequence!: number;

  @ApiProperty({
    title: 'Builder name',
  })
  @Expose()
  builderName!: string;

  @ApiProperty({
    format: 'uuid',
    title: 'Builder name Id',
    description: 'Builder name Id',
  })
  @IsUUID()
  @Expose()
  builderNameId!: string;

  @ApiProperty({
    title: 'Subdivision name',
  })
  @Expose()
  subdivisionName!: string;

  @ApiProperty({
    format: 'uuid',
    title: 'Subdivision name Id',
    description: 'Subdivision name Id',
  })
  @IsUUID()
  @Expose()
  subdivisionNameId!: string;

  @ApiProperty({
    title: 'Job plan',
  })
  @Expose()
  jobPlan!: string;

  @ApiProperty({
    format: 'uuid',
    title: 'Job plan Id',
    description: 'Job plan Id',
  })
  @IsUUID()
  @Expose()
  jobPlanId!: string;

  @ApiProperty({
    title: 'Job lot',
  })
  @Expose()
  jobLot!: string;

  @ApiProperty({
    title: 'Job group description',
  })
  @Expose()
  jobGroupDescription!: string;

  @ApiProperty({
    title: 'Job street',
  })
  @Expose()
  jobStreet!: string;

  @ApiProperty({
    title: 'Job street supplement',
  })
  @Expose()
  jobStreetSupplement!: string;

  @ApiProperty({
    title: 'Job city',
  })
  @Expose()
  jobCity!: string;

  @ApiProperty({
    title: 'Job state code',
  })
  @Expose()
  jobStateCode!: string;

  @ApiProperty({
    title: 'Job postal code',
  })
  @Expose()
  jobPostalCode!: string;

  @ApiProperty({
    title: 'Task name',
  })
  @Expose()
  taskName!: string;

  @ApiProperty({
    title: 'Task num',
  })
  @Expose()
  taskNum!: string;

  @ApiProperty({
    title: 'Task description',
  })
  @Expose()
  taskDescription!: string;

  @ApiProperty({
    title: 'Options',
  })
  @Expose()
  options!: string;

  @ApiProperty({
    format: 'uuid',
    title: 'Job Id',
    description: 'Job Id',
  })
  @IsUUID()
  @Expose()
  jobId!: string;

  @ApiPropertyOptional({
    type: () => [BuilderDto],
    title: 'Builder',
    description: 'The builder associated with this job order item',
  })
  @Expose()
  builder!: BuilderDto;

  @ApiPropertyOptional({
    type: () => SpOrderItemDto,
    title: 'Sp Order Items',
    description: 'The sp order items associated with this sp order',
  })
  @Expose()
  spOrderItems!: SpOrderItemDto[];
}
